if (!customElements.get('wlsn-graph')) {
    class WLSNGraph extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                visibleClass: 'is-visible'
            };
        }

        connectedCallback() {
            this.initObserver();
        }

        initObserver() {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.classList.add(this.classes.visibleClass);
                            observer.unobserve(this);
                        }
                    });
                },
                {
                    threshold: 0.3
                }
            );

            observer.observe(this);
        }
    }

    customElements.define('wlsn-graph', WLSNGraph);
}
